import { ScopeHierarchy, ScopeHierarchyId } from "Shared/Components/Scope/Scopes.types";

import { ScopeCategory } from "Shared/Hooks/Health/signalSettings.types";
import { SubstrateScopeHierarchies } from "./SubstrateScopeHierarchies";

export const IC3ScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.IC3ScopeHierarchy,
    DisplayName: "IC3",
    Root: {
        ScopeType: "Global",
        DisplayName: "",
        ChildScopes: [
            {
                ScopeType: "AzureCloud",
                DisplayName: "Cloud",
                ChildScopes: [
                    {
                        ScopeType: "AzureRegion",
                        DisplayName: "Region",
                        ChildScopes: []
                    }
                ]
            },
            {
                ScopeType: "AzureRegion",
                DisplayName: "Region",
                ChildScopes: [
                    {
                        ScopeType: "AzureCloud",
                        DisplayName: "Cloud",
                        ChildScopes: []
                    }
                ]
            }
        ]
    }
};

export const CosmicScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.CosmicScopeHierarchy,
    DisplayName: "Cosmic",
    Root: {
        ScopeType: "Global",
        DisplayName: "",
        ChildScopes: [
            {
                ScopeType: "CosmicRing",
                DisplayName: "Ring",
                ChildScopes: [
                    {
                        ScopeType: "AzureLocation",
                        DisplayName: "Location",
                        ChildScopes: [
                            {
                                ScopeType: "CosmicCluster",
                                DisplayName: "Cluster",
                                ChildScopes: [
                                    {
                                        ScopeType: "CosmicNamespace",
                                        DisplayName: "Namespace"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                ScopeType: "CosmicNamespace",
                DisplayName: "Namespace"
            }
        ]
    }
};

export const AzureAdScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.AzureAdScopeHierarchy,
    DisplayName: "AzureAd",
    Root: {
        ScopeType: "Type",
        DisplayName: "Type",
        ChildScopes: [
            {
                ScopeType: "Gateway",
                DisplayName: "Gateway"
            }
        ]
    }
};

export const DownDetectorScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.DownDetectorScopeHierarchy,
    DisplayName: "Down Detector",
    Root: {
        ScopeType: "WorkloadName",
        DisplayName: "Product",
        ChildScopes: [
            {
                ScopeType: "Region",
                DisplayName: "Region",
                ChildScopes: [
                    {
                        ScopeType: "Country",
                        DisplayName: "Country"
                    }
                ]
            }
        ]
    }
};

export const CosmicATMScopeHierarchy: ScopeHierarchy = {
    HierarchyId: ScopeHierarchyId.CosmicATMScopeHierarchy,
    DisplayName: "Cosmic ATM Scope Hierarchy",
    Root: {
        ScopeType: "Global",
        DisplayName: "",
        ChildScopes: [
            {
                ScopeType: "CosmicRing",
                DisplayName: "Ring",
                ChildScopes: [
                    {
                        ScopeType: "AzureLocation",
                        DisplayName: "Location",
                        ChildScopes: [
                            {
                                ScopeType: "CosmicCluster",
                                DisplayName: "Cluster",
                                ChildScopes: [
                                    {
                                        ScopeType: "CosmicNamespace",
                                        DisplayName: "Namespace",
                                        ChildScopes: [
                                            {
                                                ScopeType: "CosmicATMService",
                                                DisplayName: "Service"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const IC3ScopeHierarchies = [IC3ScopeHierarchy];
export const CosmicScopeHierarchies = [CosmicScopeHierarchy];
export const AzureAdScopeHierarchies = [AzureAdScopeHierarchy];
export const DownDetectorScopeHierarchies = [DownDetectorScopeHierarchy];

export const AllHierarchies = [
    ...SubstrateScopeHierarchies,
    ...IC3ScopeHierarchies,
    ...CosmicScopeHierarchies,
    ...AzureAdScopeHierarchies,
    ...DownDetectorScopeHierarchies,
    CosmicATMScopeHierarchy
];

export const ScopeHierarchyMapping: { [scopeCategory in ScopeCategory]: ScopeHierarchyId[] } = {
    SUBSTRATE: [
        ScopeHierarchyId.SubstrateLogicalScopeHierarchy,
        ScopeHierarchyId.SubstratePhysicalScopeHierarchy,
        ScopeHierarchyId.SubstrateAccountForestScopeHierarchy,
        ScopeHierarchyId.SubstrateCafeScopeHierarchy
    ],
    COSMIC: [ScopeHierarchyId.CosmicScopeHierarchy],
    COSMICD2: [ScopeHierarchyId.CosmicScopeHierarchy],
    COSMICB2: [ScopeHierarchyId.CosmicScopeHierarchy],
    DOWNDETECTOR: [ScopeHierarchyId.DownDetectorScopeHierarchy],
    AZUREAD: [ScopeHierarchyId.AzureAdScopeHierarchy],
    IC3: [ScopeHierarchyId.IC3ScopeHierarchy],
    SLISLO: [ScopeHierarchyId.OdspPhysicalScopeHierarchy],
    OTHER: []
};
